import { createAction } from '@reduxjs/toolkit';

export const resetToInitialState = createAction('RESET');
